import { BreakpointsOptions } from "@mui/material/styles";

export const breakpoints: BreakpointsOptions = {
    values: {
        xsMobile: 0,
        xs: 0,
        tablet: 640,
        sm: 640,
        md: 1024,
        lg: 1440,
        xl: 1920,
        "2xl": 2560,
        "3xl": 3200,
        "4xl": 4200,
        "5xl": 5120,
    },
};
